import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

// Colonna "Tag" della tabella pubblicazione: icona se l'articolo ha almeno un
// tag Moda (row.tagModa, da GET /moda/articoli). Il tooltip elenca i tag; il
// clic apre un riquadro, montato su document.body perché le celle della
// tabella tagliano ciò che esce dai loro bordi.
export default function TagModaCell({ tags }) {
  const [anchor, setAnchor] = useState(null);
  const buttonRef = useRef(null);
  const panelRef = useRef(null);
  const elenco = Array.isArray(tags) ? tags : [];

  useEffect(() => {
    if (!anchor) return undefined;
    const close = (event) => {
      if (event.type === "keydown" && event.key !== "Escape") return;
      if (event.type === "mousedown" &&
          (panelRef.current?.contains(event.target) || buttonRef.current?.contains(event.target))) return;
      setAnchor(null);
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", close);
    window.addEventListener("scroll", close, true);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("keydown", close);
      window.removeEventListener("scroll", close, true);
    };
  }, [anchor]);

  if (!elenco.length) return null;
  const descrizioni = elenco.map((tag) => tag.description || tag.code);

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className="button-reset bn bg-transparent pointer pa0 flex items-center"
        title={descrizioni.join(", ")}
        aria-label={`Tag Moda: ${descrizioni.join(", ")}`}
        aria-expanded={Boolean(anchor)}
        onClick={(event) => {
          event.stopPropagation();
          setAnchor(anchor ? null : event.currentTarget.getBoundingClientRect());
        }}
      >
        <span className="material-icons f5 scrittaColAltScuro" aria-hidden="true">sell</span>
        {elenco.length > 1 && <span className="f7 ml1">{elenco.length}</span>}
      </button>
      {anchor && createPortal(
        <div
          ref={panelRef}
          role="dialog"
          aria-label="Tag Moda dell'articolo"
          className="sfondoBiancoTema ba b--black-20 br2 shadow-4 pa2 f7 lh-copy"
          style={{ position: "fixed", top: anchor.bottom + 4, left: anchor.left, zIndex: 1000, maxWidth: 280 }}
        >
          <ul className="list pl0 ma0">
            {elenco.map((tag) => (
              <li key={tag.code}>
                {tag.description || tag.code}
                {tag.description && tag.description !== tag.code && (
                  <span className="gray"> ({tag.code})</span>
                )}
              </li>
            ))}
          </ul>
        </div>,
        document.body,
      )}
    </>
  );
}
